export default "__VITE_ASSET__vjEXfiCm__"